import { Container } from '@exploration/shared-components';
import { headlessPageDataAtom } from '@exploration/ui-utils';
import { MDSText } from '@thrivent/midwest-web';
import { useAtomValue } from 'jotai';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const Section = styled.section`
  background-color: ${(p) => p.theme.midwestColors.identityBrandTertiaryFaint};
  position: relative;
  z-index: 1;

  &:after {
    content: '';
    position: absolute;
    display: block;
    left: 0;
    right: 0;
    top: 100%;
    height: 9rem;
    background-color: ${(p) =>
      p.theme.midwestColors.identityBrandTertiaryFaint};
  }
`;

export const HeaderSectionContainer = styled(Container)`
  padding-top: 4rem;
  padding-bottom: 3rem;
`;

// --------------------------------------------------------------------------

export const HeaderSection = () => {
  const pageData = useAtomValue(headlessPageDataAtom);
  const { text } = pageData ?? {};

  return (
    <Section>
      <HeaderSectionContainer>
        <MDSText.HeroLg as="h1">{text?.['hero-section-title']}</MDSText.HeroLg>
        {
          // This h2 is a bit of a hack. Lighthouse complains about us
          // "skipping" from an h1 to h3s on the card elements, preventing 100 on accessibility
        }
        <MDSText.Subtitle as="h2">
          {text?.['hero-section-description']}
        </MDSText.Subtitle>
      </HeaderSectionContainer>
    </Section>
  );
};
